import React from 'react';
import InsuranceIcon from '../icons/InsuranceIcon';

const InsuranceTypeField = ({ products, selectedInsurance, onSelect }) => {
  if (!products || products.length === 0) return null;

  // Mapear nombre del producto a tipo de icono
  const getIconType = (productName) => {
    const name = productName.toLowerCase();
    if (name.includes('puntual')) return 'single';
    if (name.includes('nacional')) return 'national';
    if (name.includes('multiple') || name.includes('múltiple')) return 'multiple';
    if (name.includes('mayor') || name.includes('longevo') || name.includes('86')) return 'seniors';
    return 'single'; // default
  };

  return (
    <div className="sf-insurance-type-field">
      {products.map((product) => (
        product.active && (
          <label
            key={product.id}
            className={`sf-insurance-option ${selectedInsurance && selectedInsurance.id === product.id ? 'active' : ''}`}
            onClick={() => onSelect(product)}
          >
            <input
              type="radio"
              name="insuranceType"
              value={product.id}
              checked={selectedInsurance && selectedInsurance.id === product.id}
              onChange={() => {}}
              className="sf-insurance-radio"
            />
            <span className="sf-insurance-radio-circle">
              <span className="sf-insurance-radio-dot" />
            </span>
            <InsuranceIcon
              type={getIconType(product.name)}
              size={20}
              className="sf-insurance-icon"
            />
            <span className="sf-insurance-name">{product.name.replace('Multiples', 'Múltiples')}</span>
          </label>
        )
      ))}
    </div>
  );
};

export default InsuranceTypeField;
